module.exports = "<input\n  type=\"radio\"\n  name=\"{{ vm.name }}\"\n  id=\"{{ vm.id }}\"\n  class=\"form-control\"\n  ng-class=\"vm.className\"\n  ng-model=\"vm.model\"\n  ng-value=\"vm.value\"\n  ng-change=\"vm.change(value)\"\n  ng-focus=\"vm.focus()\"\n  ng-blur=\"vm.blur()\"\n  ng-change=\"vm.change()\"\n  ng-required=\"vm.isRequired\"\n  ng-disabled=\"vm.disabled\">\n<label for=\"{{ vm.id }}\" translate=\"{{ vm.label }}\" translate-values=\"vm.labelValues\" translate-compile></label>"


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fino/ng1-form-control/src/templates/formControl.radio.html
// module id = 1488
// module chunks = 12